export default __webpack_public_path__ + "static/media/p2.f8790ebe.jpg";